import { WalletFilled } from "@fluentui/react-icons";
import Button from "components/Buttons/Button";
import Render from "components/Common/Render";
import { routes } from "constants/routes";
import { PlanActivationStatus } from "enum/common";
import useMixpanel from "hooks/useMixpanel";
import { useNavigate } from "react-router-dom";

interface TopupDetailsProps {
  businessStats: BusinessStatsType;
  business: BusinessType;
  plans: BusinessPlanType[];
  setShowTransferDialog: (transferAmount: number) => void;
  loading: boolean;
}
const TopupDetails: React.FC<TopupDetailsProps> = ({
  businessStats,
  plans,
  setShowTransferDialog,
  loading,
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();
  return (
    <div
      className={`md:bg-[url("https://bludot-community-production.s3.us-west-2.amazonaws.com/media/public/business_portal_images/Wallet+Balance+BG.png")] 
      bg-[url("https://bludot-community-production.s3.us-west-2.amazonaws.com/media/public/business_portal_images/MobWalletBalanceBG.jpg")]
      md:bg-contain bg-cover bg-no-repeat rounded-2xl mb-2 flex md:flex-row flex-col md:items-center md:p-10 p-6 md:gap-8 gap-4 w-full h-full md:aspect-813/161`}
    >
      <div className="flex-1 flex-col gap-2 flex mb-4">
        <div className="font-medium text-white text-2xl">
          Rewards Fund Balance
        </div>
        <div className="text-primary font-semibold flex gap-2">
          <WalletFilled color={"#fff"} fontSize={40} className="self-center" />
          <span className="text-white text-4xl">
            ${businessStats?.walletBalance || 0}
          </span>
        </div>
      </div>
      <div>
        <Button
          label={"Transaction History"}
          type={"button"}
          variant="secondary"
          customClass="rounded-4xl !bg-white !text-primary"
          onClick={() => {
            trackEvent("topup_history_button_Clicking");
            navigate(routes.topupHistory);
          }}
        />
      </div>
      <Render
        when={
          !!businessStats?.walletBalance &&
          !!plans?.length &&
          (plans[0]?.status === PlanActivationStatus.DE_ACTIVATED ||
            plans[0]?.status === PlanActivationStatus.EXPIRED)
        }
      >
        <div>
          {" "}
          <Button
            onClick={() => {
              trackEvent("transfer_balance_button_Clicking", {
                balance: businessStats?.walletBalance,
              });
              setShowTransferDialog(businessStats?.walletBalance || 0);
            }}
            label={"Transfer Balance"}
            type={"button"}
            customClass="rounded-4xl !bg-white !text-primary"
          />
        </div>
      </Render>
    </div>
  );
};

export default TopupDetails;
